import React from "react";
import logo from "../assets/branding/logo_maidly.svg";

const Logo = ({
  className = "h-8 w-auto sm:h-9 md:h-10",
  alt = "Maidly logo",
  title = "Maidly",
  ...props
}) => {
  return (
    <img
      src={logo}
      alt={alt}
      title={title}
      className={className}
      loading="eager"
      draggable={false}
      {...props}
    />
  );
};

export default Logo;
